<template>
  <div class="list-item-content">
    <div class="list-item-content-title list-item-content-title-underline one-liner"
         @click="openFilter">
      {{ filter.description }}
    </div>

    <base-btn-group :state="state"
                    button-inactive
                    button-warn
                    button-block
                    @click="changeAction" />
  </div>
</template>

<script>
  export default {
    props: {
      filter: {
        type: Object,
        required: true
      },

      childId: {
        type: String,
        required: true
      },

      modeId: {
        type: String,
        required: true
      }
    },

    data: () => ({
      state: null
    }),

    created() {
      this.initState()
    },

    computed: {
      ...mapGetters('children', {
        getCategorySettings: 'getCategorySettings'
      }),

      categorySettings() {
        return this.getCategorySettings(this.childId)
      },

      setting() {
        return this.categorySettings.find(setting => setting.category_id === this.filter.id)
      }
    },

    methods: {
      initState() {
        this.state = this.setting ? this.setting.action : 'inactive'
      },

      openFilter() {
        this.$emit('openFilter', this.filter)
      },

      changeState(state) {
        this.switchState = state
      },

      changeAction(action) {
        this.$emit('changeAction', {
          ...this.filter,
          id: action === 'inactive' ? this.setting.id : this.filter.id,
          action
        })
      }
    },

    watch: {
      categorySettings() {
        this.initState()
      }
    }
  }
</script>